import { Controller } from '@hotwired/stimulus';
import application from '~/stimulus_application';
import Prism from 'prismjs';

// Languages
// import 'prismjs/components/prism-ruby';
import 'prismjs/components/prism-json';
// import 'prismjs/components/prism-yaml';
// import 'prismjs/components/prism-bash';
// import 'prismjs/components/prism-typescript';
// import 'prismjs/components/prism-javascript';
// import 'prismjs/components/prism-markup'; // html/xml

// Plugins
import 'prismjs/plugins/line-numbers/prism-line-numbers';
import 'prismjs/plugins/line-numbers/prism-line-numbers.css';

// Theme
import 'prismjs/themes/prism-tomorrow.css';

export default class CodeBlock extends Controller {
  static targets = ['code'];

  declare readonly codeTarget: HTMLElement;
  declare readonly hasCodeTarget: boolean;

  connect() {
    if (this.hasCodeTarget) {
      Prism.highlightElement(this.codeTarget);
    }
  }
}

application.register('ui--code-block', CodeBlock);
